import $ from 'jquery';

export const elements = {
    edit: '.js-SingleComment-Edit',
    add: '.js-SingleComment-Add',
    delete: '.js-SingleComment-Delete',
};

export const edit = () => {
};

export const onClick = function () {
    edit($(this));
};

export default {
    init(params) {
        params.$document.on('click', elements.edit, onClick);
    },
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/single-edit.js